import React from 'react';
import './style.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CoverImage from 'Assets/present-img.png';

class CoverPhoto extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            coverImagePreviewUrl: null,
            cover_image_url: '',
            pageLoader: true,
            coverImgLoader: false,
            coverImgFile: null
        }
    }
    componentDidMount() {
        const { cityImg } = this.props;
        this.setState({
            cover_image_url: cityImg
        })
    }
    // Change Cover Image method
    onChangeCoverFile = (event) => {
        event.stopPropagation();
        event.preventDefault();
        let files = event.target.files;
        var index;
        for (index = 0; index < files.length; index++) {
            var item = files[index];
            this.handleCoverLoadImage(item);
        }
        this.setState({ item });
    }
    // Cover image method
    handleCoverLoadImage(item) {
        this.setState({ coverImgLoader: true, coverImgFile: item })
        this.props.changedImg(item);
        var pictures = [];
        if (item) {
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState(() => ({
                    coverImagePreviewUrl: reader.result,
                }));
                pictures.push({ 'image': item, 'coverImagePreviewUrl': reader.result });
            };
            reader.readAsDataURL(item);
        }

    }
    render() {
        return (
            <div className="container pad-bot20">
                <Row >
                    <Col lg={12} className="coverphoto pad0">
                        <div >
                            <div className="pad-tb30 cover-border">
                                <h3>{this.props.coverHead}</h3>
                                <p>{this.props.coverDescription}</p>
                            </div>
                        </div>
                        {/* 
                        <div className="current-photo pad-tb30 cover-border">
                        <h5>Current Cover Photo</h5>
                        <div className="cityCoverImg">
                        <img src={this.props.coverImage} className="img-fluid" alt="cover img" />
                        </div>
                        </div>
                        */}
                        <div className="pad-cover30 cover-border">
                            <h4 className="coverHeading">{this.props.currentImageText}</h4>
                            <fieldset>
                                <div className="input-file-row-1 coverImgData">
                                    <div className="upload-file-cover">
                                        {
                                            (this.state.coverImagePreviewUrl !== null)
                                                ?
                                                <img id="preview_image" src={this.state.coverImagePreviewUrl} alt="upload-img" />
                                                :
                                                (this.state.cover_image_url !== null && this.state.cover_image_url !== undefined)
                                                    ?
                                                    <div>
                                                        <img src={this.state.cover_image_url} alt="api-img" />
                                                    </div>
                                                    :
                                                    <img id="preview_image" src={CoverImage} alt="default-img" />
                                        }
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <div className="pad-img20">
                            <div className='one_opacity_0'>
                                <input type="file" label="add"
                                    id="myInput"
                                    ref={(ref) => this.upload = ref}
                                    style={{ display: 'none' }}
                                    onChange={this.onChangeCoverFile.bind(this)}
                                />
                            </div>

                            <div
                                className="coverUploadImage"
                                label="Open File"
                                // primary={false}
                                onClick={() => { this.upload.click() }}> {this.props.replaceImageBtn}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
export default CoverPhoto;